// export function codeToName(code?: string): string {
//     switch (code) {
//         case 'U':
//             return 'unknown';
//         case 'F':
//             return 'further';
//         case '1':
//             return 'excellent';
//         case '2':
//             return 'good';
//         case '3':
//             return 'reasonable';
//         case '4':
//             return 'moderate';
//         case '5':
//             return 'poor';
//         case '6':
//             return 'bad';
//         default:
//             return 'invalid';
//     }
// }

export function craConditionToColorCode(code?: number): string {
    switch (code) {
        case 1:
            return '#5ec54b';
        case 2:
            return '#f4b027';
        case 3:
            return '#fd7808';
        case 4:
            return '#d73f2d';
        default:
            return '#6eb3f4'; // '#999999';
    }
}
